import { Route } from '@angular/router';

export const errorPageRouteConfig: Route = {
  path: '',
  loadComponent: () => import('./error-page.component').then((c) => c.ErrorPageComponent)
};
